import React, { useState } from 'react';
import { Card, CardContent, CardMedia, Grid } from '@mui/material';
import { useData } from '../../../contexts';
import {
  BarChartComparissonMobile,
  BarChartDeltaMobile,
} from '../../BarChart/BarChart';
import { MdHelpOutline } from 'react-icons/md';
import { Tooltip, TooltipTrigger, TooltipContent } from '../../Tooltip/Tooltip';
import { InfoPanelMobile } from '../../InfoPanelMobile/InfoPanelMobile';

export const EvolutiescoreMobile = (props: any) => {
  const { data, allIndicators, interactieveToolPath, clickHandler } = props;
  const {
    radarColors,
    selectedGemeente,
    selectedTopic,
    locale,
    interfaceColor,
    deltaColors,
  } = useData();

  const [keysInStack, setKeysInStack] = useState([
    'valueReal',
    'valueRealVorig',
  ]);

  return (
    <Card className="card-borderless">
      <CardContent>
        <div
          className={'vl-typography'}
          style={{
            paddingLeft: '24px',
            paddingRight: '4px',
            marginBottom: '24px',
            marginRight: '16px',
          }}
        >
          <Tooltip>
            <TooltipTrigger style={{ marginBottom: '2px' }}>
              <h5 className="page-title-mobile">
                Hoe evolueert {selectedGemeente.label} ten opzichte van de
                burgerbevraging {data.length > 0 && data[0].jaarVorig}?{' '}
                <MdHelpOutline
                  style={{
                    cursor: 'pointer',
                    fontSize: '14px',
                    color: interfaceColor,
                    top: '2px',
                    position: 'relative',
                    display: 'inline',
                  }}
                />
              </h5>
            </TooltipTrigger>
            <TooltipContent className="TooltipMobile">
              <p>
                In de eerste grafiek tonen we per indicator het percentage van{' '}
                {data.length > 0 && data[0].jaar} en{' '}
                {data.length > 0 && data[0].jaarVorig}.
              </p>

              <p>
                In de tweede grafiek brengen we het absoluut verschil uitgedrukt
                in procentpunten in beeld.
              </p>

              <p>
                De indicatoren zijn gerangschikt van sterkste stijger tot
                sterkste daler.
              </p>
              <br />

              <p>
                In de interactieve toepassing vind je alle surveyindicatoren
                terug per thema.
              </p>

              <p>
                Via de knop 'Meer informatie' kan je per indicator meteen naar
                de interactieve toepassing gaan.
              </p>
            </TooltipContent>
          </Tooltip>
          <p className={'page-subtitle-mobile'}>
            Welke indicatoren uit de kernset voor het thema{' '}
            {selectedTopic.thema} kennen een afname of toename ten opzichte van
            de resultaten uit de burgerbevraging{' '}
            {data.length > 0 && data[0].jaarVorig}?
          </p>{' '}
          <div>
            <InfoPanelMobile
              allIndicators={allIndicators}
              data={data}
              interactieveToolPath={interactieveToolPath}
            />
          </div>
          <hr style={{ marginRight: '12px' }} />
        </div>
      </CardContent>
      <CardMedia style={{ width: '100%' }}>
        {data !== undefined && data.length > 0 ? (
          <Grid container>
            <Grid item xs={12} sx={{ height: '40px' }}>
              <h5 style={{ textAlign: 'center', fontSize: '14px' }}>
                <span style={{ color: radarColors[0] }}>{data[0].jaar}</span>{' '}
                versus{' '}
                <span style={{ color: radarColors[1] }}>
                  {data[0].jaarVorig}
                </span>
              </h5>
            </Grid>
            <Grid item xs={12} sx={{ height: data.length * 44 + 86 }}>
              <BarChartComparissonMobile
                data={data}
                keysInStack={keysInStack}
                colors={radarColors}
                locale={locale}
                survey={data?.detail?.survey === '0' ? false : true}
                legend={false}
                labels={[data[0].jaar, data[0].jaarVorig]}
              />
            </Grid>
            <Grid item xs={12} sx={{ height: '80px', paddingTop: '30px' }}>
              <h5
                style={{
                  textAlign: 'center',
                  fontSize: '14px',
                }}
              >
                <span style={{ color: deltaColors[1] }}>Afname</span> of{' '}
                <span style={{ color: deltaColors[0] }}>toename</span> t.o.v.{' '}
                {data.length > 0 && data[0].jaarVorig}
              </h5>
            </Grid>
            <Grid item xs={12} sx={{ height: data.length * 44 + 86 }}>
              <BarChartDeltaMobile
                data={data}
                colors={deltaColors}
                locale={locale}
              />
            </Grid>
          </Grid>
        ) : (
          <Grid container style={{ padding: '16px' }}>
            <Grid
              item
              xs={12}
              pl={5}
              pr={5}
              minHeight={'160px'}
              sx={{
                alignItems: 'center',
                display: 'flex',
                justifyContent: 'center',
                width: '100%',
              }}
            >
              <p style={{ fontSize: '11px' }}>Geen data gevonden</p>
            </Grid>
          </Grid>
        )}
      </CardMedia>
    </Card>
  );
};
